export const isProduction = process.env.NODE_ENV === 'production'
export const MDELLO_X_API_KEY =
  'af0ec7b5690129d52849ec55d2c7424ae4694aa15051016e'
export const HAPTTIC_X_API_KEY = 'd8263f7b-03b3-4dc2-8693-3ab6cacd88b9'
